import { createFeatureSelector, createSelector } from '@ngrx/store'
import { AggregationsState } from '@features/aggregations/store/states/aggregations.state'
import {
  AGGREGATIONS_AVERAGE_SELECTABLE_MODE,
  AGGREGATIONS_FEATURE_TOKEN
} from '@features/aggregations/constants/aggregation.constants'
import { AggregationContext, Aggregations, AggregationSelectable } from '../../models/aggregations.models'

export const selectAggregationsFeature = createFeatureSelector<AggregationsState>(AGGREGATIONS_FEATURE_TOKEN)

export const selectAggregationsModeList = createSelector(selectAggregationsFeature, (state) => state.aggregationModes)
export const selectAggregationsLeftAggregation = createSelector(
  selectAggregationsFeature,
  (state): AggregationSelectable => state.leftAggregation
)
export const selectAggregationsRightAggregation = createSelector(
  selectAggregationsFeature,
  (state): AggregationSelectable => state.rightAggregation
)

export const selectAggregationsDemarcation = createSelector(selectAggregationsFeature, (state) => state.demarcation)
export const selectAggregationsIsVsEnabled = createSelector(selectAggregationsFeature, (state) => state.isVsEnabled)
export const selectAggregationsIsMatch = createSelector(selectAggregationsFeature, (state) => state.isMatch)
export const selectAggregationsContext = createSelector(selectAggregationsFeature, (state) => state.context)
export const selectAggregationContextMetadata = createSelector(
  selectAggregationsIsVsEnabled,
  selectAggregationsIsMatch,
  selectAggregationsDemarcation,
  (isVsEnabled, isMatch, demarcation): AggregationContext => ({ isVsEnabled, isMatch, demarcation })
)
export const selectAggregation = createSelector(selectAggregationsFeature, (state) => state.aggregation)
export const selectAggregations = createSelector(
  selectAggregationsLeftAggregation,
  selectAggregationsRightAggregation,
  selectAggregation,
  (leftAggregation, rightAggregation, aggregation): Aggregations => ({ leftAggregation, rightAggregation, aggregation })
)

export const selectAggregationModesToRank = createSelector(selectAggregationsModeList, (modes) =>
  (modes || []).reduce((list, mode) => {
    const _mode = { ...mode }
    if (mode.id !== 'CompetitionAverage') {
      _mode.label = `${_mode.text}_SHORT`
      list.push(_mode)
    }

    return list
  }, [])
)

export const selectAggregationByContext = createSelector(
  selectAggregationsLeftAggregation,
  selectAggregation,
  selectAggregationsIsVsEnabled,
  (leftAggregation, aggregation, isVsEnabled) => {
    return isVsEnabled ? aggregation : leftAggregation
  }
)

export const selectAggregationToRank = createSelector(selectAggregationByContext, (aggregation) =>
  aggregation.id === 'CompetitionAverage' ? AGGREGATIONS_AVERAGE_SELECTABLE_MODE : aggregation
)

export const selectAggregationsModeListWithoutCompetitionAverage = createSelector(selectAggregationsFeature, (state) =>
  state.aggregationModes?.filter((a) => a.id !== 'CompetitionAverage')
)
